import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { imageMapLayer } from 'esri-leaflet';
import L from 'leaflet';

const SATELLITE_URL =
  'https://dubaisdi.geodubai.ae/image/rest/services/RASTER/MOSAIC_Satellite_Dubai_Hatta_062025_30CM_V1/ImageServer';

const FALLBACK_URL =
  'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';

export default function EsriImageLayer() {
  const map = useMap();

  useEffect(() => {
    const layer = imageMapLayer({ url: SATELLITE_URL, opacity: 1, pane: 'tilePane' });
    let fallback = null;

    layer.on('requesterror', () => {
      if (!fallback) {
        fallback = L.tileLayer(FALLBACK_URL, { pane: 'tilePane', maxZoom: 19 }).addTo(map);
      }
    });

    layer.addTo(map);

    return () => {
      map.removeLayer(layer);
      if (fallback) map.removeLayer(fallback);
    };
  }, [map]);

  return null;
}
